export default __webpack_public_path__ + "static/media/hm-pop-img.12abe435.webp";